import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0A0D0C] flex items-center justify-center relative overflow-hidden">
      {/* Noise Texture */}
      <div className="absolute inset-0 noise-overlay pointer-events-none" />
      
      {/* Background Crown Watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none">
        <img 
          src="/crilam-crown-white.png" 
          alt="" 
          className="w-[500px] h-auto"
        />
      </div>
      
      {/* Content */}
      <div className="relative z-10 text-center px-6">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <Link to="/">
            <img 
              src="/crilam-logo-oval.png" 
              alt="CriLam Decorative" 
              className="h-20 md:h-24 w-auto mx-auto hover:opacity-80 transition-opacity"
            />
          </Link>
        </motion.div>
        
        {/* 404 Text */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <h1 className="text-[120px] md:text-[180px] font-bold text-[#D4AF37] leading-none font-['Outfit']">
            404
          </h1>
        </motion.div>
        
        {/* Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <h2 className="text-2xl md:text-3xl font-semibold text-white mb-4 font-['Outfit']">
            Page Not Found
          </h2>
          <p className="text-white/60 mb-10 max-w-md mx-auto">
            The page you're looking for doesn't exist or has been moved. Let's get you back on track.
          </p>
        </motion.div>
        
        {/* Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="flex flex-wrap justify-center gap-4"
        >
          <Link to="/">
            <motion.button
              className="flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-[#0A0D0C] font-medium hover:bg-white transition-colors"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <Home className="h-5 w-5" />
              Back to Home
            </motion.button>
          </Link>
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 px-8 py-4 border border-white/30 text-white hover:bg-white/10 transition-colors"
          >
            <ArrowLeft className="h-5 w-5" />
            Go Back
          </button>
        </motion.div>
        
        {/* Contact Info */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-12 text-white/40 text-sm"
        >
          Need help? Call us at{' '}
          <a href="tel:8298297475" className="text-[#D4AF37] hover:underline">
            8298297475
          </a>
        </motion.p>
      </div>
    </div>
  );
};

export default NotFound;
